var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import throttle from 'lodash/throttle';

import './ScrollWrapper.scss';

var ScrollWrapper = function (_React$Component) {
    _inherits(ScrollWrapper, _React$Component);

    function ScrollWrapper() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ScrollWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollWrapper.__proto__ || Object.getPrototypeOf(ScrollWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            shouldShowTopScrollShadow: false,
            shouldShowBottomScrollShadow: false,
            isScrollHeightEqualClientHeight: false
        }, _this.componentDidMount = function () {
            var newState = _this.getScrollShadowState();
            _this.setState(newState);
        }, _this.onContentScroll = function () {
            var newState = _this.getScrollShadowState();
            _this.setState(newState);
        }, _this.onContentClick = function () {
            var newState = _this.getClickShadowState();
            _this.setState(newState);
        }, _this.getClickShadowState = function () {
            var _ref2 = _this.scrollRef || {},
                scrollTop = _ref2.scrollTop,
                scrollHeight = _ref2.scrollHeight,
                clientHeight = _ref2.clientHeight;

            var newState = {};

            /**
             * This case handles when the scrollview does not have enough elements to scroll and a collapsible card was opened.
             */
            if (scrollTop === 0 && scrollHeight === clientHeight) {
                newState.shouldShowBottomScrollShadow = true;
                newState.isScrollHeightEqualClientHeight = true;
            }

            /**
             * This case handles when the scrollview has enough elements to scroll and a collapsible card was opened.
             */
            if (scrollTop === 0 && scrollHeight > clientHeight) {
                if (_this.state.isScrollHeightEqualClientHeight) {
                    newState.shouldShowBottomScrollShadow = false;
                }
                newState.isScrollHeightEqualClientHeight = false;
            }

            /**
             * This case handles when we have already partially scrolled and a collapsible card was opened.
             */
            if (scrollTop > 0) {
                if (scrollTop + clientHeight === scrollHeight) {
                    newState.shouldShowBottomScrollShadow = true;
                } else if (scrollHeight > clientHeight) {
                    newState.shouldShowBottomScrollShadow = false;
                }
            }

            return newState;
        }, _this.getScrollShadowState = function () {
            var _ref3 = _this.scrollRef || {},
                scrollTop = _ref3.scrollTop,
                scrollHeight = _ref3.scrollHeight,
                clientHeight = _ref3.clientHeight;

            var newState = {};

            if (scrollTop > 0 && scrollTop < scrollHeight - clientHeight) {
                newState.shouldShowTopScrollShadow = true;
                newState.shouldShowBottomScrollShadow = true;
            }

            if (scrollTop === 0) {
                newState.shouldShowTopScrollShadow = false;
            }

            if (scrollTop < scrollHeight - clientHeight) {
                newState.shouldShowBottomScrollShadow = true;
            }

            if (scrollTop === scrollHeight - clientHeight) {
                newState.shouldShowBottomScrollShadow = false;
            }

            return newState;
        }, _this.scrollRef = null, _this.throttledOnContentScroll = throttle(_this.onContentScroll, 100), _temp), _possibleConstructorReturn(_this, _ret);
    }

    /** Note: This will only get triggered if the child elements of ScrollWrapper do not have a stopPropagation method attached to their click events.
     * Also, asynchronous updates triggered by clicks will not fire this method.
     */


    // Throttle to 10 fps


    _createClass(ScrollWrapper, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                scrollRefFn = _props.scrollRefFn,
                rest = _objectWithoutProperties(_props, ['children', 'className', 'scrollRefFn']);

            var _state = this.state,
                shouldShowTopScrollShadow = _state.shouldShowTopScrollShadow,
                shouldShowBottomScrollShadow = _state.shouldShowBottomScrollShadow;


            var classes = classNames('scroll-container', className, {
                'is-showing-top-shadow': shouldShowTopScrollShadow,
                'is-showing-bottom-shadow': shouldShowBottomScrollShadow
            });

            return React.createElement(
                'div',
                _extends({ className: classes }, rest),
                React.createElement(
                    'div',
                    {
                        className: 'scroll-wrap-container',
                        onClick: this.onContentClick,
                        onScroll: this.throttledOnContentScroll,
                        ref: function ref(el) {
                            _this2.scrollRef = el;
                            scrollRefFn(el);
                        }
                    },
                    children
                )
            );
        }
    }]);

    return ScrollWrapper;
}(React.Component);

ScrollWrapper.defaultProps = {
    scrollRefFn: noop
};
ScrollWrapper.propTypes = {
    /** Contents for this element */
    children: PropTypes.node.isRequired,

    /** Optional class name(s) to pass thru to the component */
    className: PropTypes.string,

    /** Optional function to get the scrollRef in parent components */
    scrollRefFn: PropTypes.func.isRequired
};


export default ScrollWrapper;
import PropTypes from 'prop-types';